export const USER_OBTAINED_SESSION = 'USER_OBTAINED_SESSION' as const;
export const USER_OBTAINED_NO_SESSION = 'USER_OBTAINED_NO_SESSION' as const;
